<template>
  <section id="perks" :class="$style.container">
    <Wrapper>
      <Title :title-params="content.title" :class="$style.title" />
      <ul :class="$style.categoryList">
        <li v-for="(category, categoryIndex) in items" :key="categoryIndex" :class="$style.category">
          <a :href="formatedLink(category)">
            {{ category }}
          </a>
        </li>
      </ul>
    </Wrapper>
  </section>
</template>

<script>
import Title from '~/components/Title'

export default {
  name: 'Categories',

  components: {
    Title,
  },

  props: {
    slice: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    content() {
      return this.slice.primary
    },

    items() {
      return this.slice.items
    },
  },

  methods: {
    formatedLink(name) {
      return `#${name.toLowerCase().split(' ').join('-')}`
    },
  },
}
</script>

<style lang="scss" module>
.container {
  padding: 48px 24px;

  background-color: $bluko-800;
}

.title {
  color: white;
  font-weight: 200;
  font-size: 40px;
  line-height: 48px;
  text-align: center;
}

.categoryList {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
  margin-top: 40px;

  @include above(small) {
    gap: 24px;
  }
}

.category a {
  @include typo-headline;
  display: block;
  padding: 8px 20px;
  border-radius: 24px;

  color: white;

  text-decoration: none;

  background-color: $bluko-700;

  transition-duration: 0.3s;

  transition-property: color, background-color;

  &:hover {
    background-color: $bluko-600;
  }
}
</style>
